import { Api } from "./base";

const _headers = () => {
  return {
    Authorization:
      "JWT " + require("store").default.getState().onboard.user.auth_token,
    "Content-Type": "application/json"
  };
};

export default {
  getPlatformList(page = 0) {
    return Api.getRequest(`/misc/v1/admin-platform/?offset=${page}`, _headers());
  },
  createPlatform(payload) {
    return Api.post("/misc/v1/admin-platform/", payload, _headers());
  },
  updatePlatform(id, payload) {
    return Api.put(`/misc/v1/admin-platform/${id}/`, payload, _headers());
  },
  getContentPolicySchema() {
    return Api.getRequest("/misc/v1/admin-content-policy-schema/", _headers());
  }
};
